import React from "react";
import {PriceType} from "state/types";

export interface MedicationPriceElementProps {
    price: PriceType,
    mainAxisArrangement?: string
}

const MedicationPriceElement = ({price, mainAxisArrangement = "center"}: MedicationPriceElementProps) => {
    const currencySymbol = price.currencySymbol;
    const decimalSeparator = ".";
    const wholeValue = Math.floor(price.amount);
    const fractionalValue = (price.amount % 1).toFixed(2).substring(2);

    return (
        <pui-section flowDirection="horizontal" mainAxisArrangement={mainAxisArrangement} spacingtop="small"
                     spacingbottom="mini">
            <pui-text class="currency-symbol" fontweight="normal" textsize="small" input={currencySymbol}/>
            <pui-text class="currency-amount" fontweight="normal" input={wholeValue + decimalSeparator + fractionalValue}/>
        </pui-section>
    )
}

export default MedicationPriceElement;
